import request from '@/utils/request'

export function get_leader_board_list (params) {
  return request({
    url: '/poker-api/leader_board/list',
    method: 'get',
    params
  })
}

export function get_leader_board_user (params) {
  return request({
    url: '/poker-api/leader_board/user',
    method: 'get',
    params
  })
}

export function get_leader_board_cycle (params) {
  return request({
    url: '/poker-api/leader_board/cycle',
    method: 'get',
    params
  })
}

